module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Temperature-half-e256d70cf095824e9754d09461478a3e.svg";